"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureQuantcastConsentManager = configureQuantcastConsentManager;
var _quantcastConsentManager = require("./quantcastConsentManager");
const quantcastConsentManager = _quantcastConsentManager.quantcastConsentManager;
function configureQuantcastConsentManager(config) {
  const {
    quantcastConsentManagerEnabled,
    quantcastAccountId,
    logInfo
  } = config;
  if (!quantcastConsentManagerEnabled) {
    return;
  }
  logInfo(`Configuring Quantcast with: ${JSON.stringify({
    quantcastAccountId
  })}`);
  quantcastConsentManager(quantcastAccountId);
}